import { Box, Spinner } from '@zillow/constellation-10';

type SpinnerContainerProps = {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  height?: string;
  padding?: string;
};

const SpinnerContainer = ({ size = 'sm', height = '200px', padding = '64px' }: SpinnerContainerProps) => (
  <Box
    css={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    style={{
      padding,
      height,
    }}
    data-testid="spinnerContainer"
  >
    <Spinner size={size} />
  </Box>
);

export default SpinnerContainer;
